module.exports = {
    label: {
        registertitle: 'Kostenlose KRZ.ChurchTools-Installation anfordern',
        churchname: 'Vollständiger Name der Kirchengemeinde/des Werks',
        city: 'Stadt',
        countrycode: 'Land',
        instancename: {
            short: 'KRZ.ChurchTools Kurzname',
            long: 'Kurzname Ihrer KRZ.ChurchTools-Installation'
        },
        yoururl: 'Ihre daraus folgende KRZ.ChurchTools URL: ',
        baselanguage: {
            short: 'Sprache',
            long:
                'Sprache, in der Ihr KRZ.ChurchTools System installiert wird. Später ist für jeden Benutzer eine Auswahl vieler weiterer Sprachen möglich.'
        },
        contactperson: 'Angaben zu Ihnen',
        contactpersonDenomination: 'Angaben zum Administrator',
        churchinformation: 'Angaben zu Ihrer Kirchengemeinde',
        churchinformationDenomination: 'Angaben zur Kirchengemeinde',
        optionalInformation: 'Weitere Informationen',
        name: 'Name',
        firstname: 'Vorname',
        lastname: 'Name',
        email: 'E-Mail',
        phone: 'Telefon für Rückfragen',
        discountcode: 'Rabatt-Code',
        comments: 'Sonstige Anmerkungen',
        checkagbs: 'Ich bin mit der Geltung der {link} einverstanden.',
        checkgdpr: 'Ich habe die {link} zur Kenntnis genommen.',
        checknewsletter:
            'Ich würde gerne den monatlichen Newsletter mit Tipps und Neuigkeiten von KRZ.ChurchTools erhalten. Mir ist bewusst, dass ich meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen kann. Hinweis: Ein entsprechender Abmeldelink befindet sich in jedem Newsletter.',
        checknewsletterDenomination:
            'Der Administrator soll den monatlichen Newsletter mit Tipps und Neuigkeiten von KRZ.ChurchTools erhalten.',
        agbs: 'AGB (mit Vertrag zur Auftragsverarbeitung)',
        gdpr: 'Datenschutzhinweise',
        website: 'Webseite oder Facebook Seite',
        currentWebsite: 'Bisherige Webseite oder Facebook Seite',
        username: 'Benutzername',
        password: 'Passwort',
        login: 'Support Login',
        setupService: 'Einrichtungs-Service',
        setupMeeting: 'Terminauswahl',
        useSetupService: 'Kostenlosen Einrichtungs-Service nutzen',
        pleaseSelectDate: 'Bitte wählen Sie einen Termin aus:',
        with: 'mit',
        churchtoolsWebsite: 'ChurchTools Website',
        registerWebsite: 'ChurchTools Website zusätzlich kostenlos testen',
        alreadyCustomer: 'Ihre Kirchengemeinde nutzt bereits KRZ.ChurchTools?',
        notYetCustomer: 'Ihre Kirchengemeinde ist noch kein KRZ.ChurchTools-Kunde?',
        niceHeader: 'Wie schön, dass Sie ChurchTools ausprobieren möchten!',
        problemHeader: 'Welches Anliegen oder Problem möchten Sie gerne mithilfe von ChurchTools lösen?',
        problemDescription:
            'Beantworten Sie diese Frage möglichst konkret (max. 250 Zeichen). Dies hilft Ihnen, sich noch stärker auf das zu fokussieren, was Sie in den kommenden 30 Tagen mit der Testinstallation von ChurchTools erreichen möchten.',
        justLooking: '"Ich möchte eigentlich nur gucken."',
        justLookingDescription:
            'Für diesen Fall empfehlen wir Ihnen unsere Demo-Installation, die perfekt für einen schnellen Überblick über die vielen Funktionen von ChurchTools geeignet ist. Sie ist bereits mit Beispieldaten befüllt, so dass Sie alle Module mühelos testen können.',
        justLookingDescription2:
            'Sie haben volle 3 Tage Zeit, um die Demo zu erkunden. Sollte diese Zeit nicht ausreichen, können Sie jederzeit eine neue Demo erstellen.',
        andNowAFewDetails: 'Und nun noch ein paar Angaben ...',
        detailsAboutYourChurch: '... zu Ihrer Kirchengemeinde',
        detailsAboutYou: '... zu Ihnen als Person',
        institutionId: 'Institutions-ID in der Kirchendatenbank der Nordkirche'
    },
    button: {
        register: "Los geht's",
        registering: 'Bitte warten...',
        login: 'Jetzt einloggen',
        demo: 'Zur Demo'
    },
    link: {
        dataprivacy: 'https://church.tools/de/data-security',
        impressum: 'https://church.tools/de/impressum/',
        agbs: 'https://church.tools/de/agb',
        demo: 'https://ccp.church.tools/demo',
        demoXXX: 'https://www.church.tools/de/churchtools-testen?cta=ccp'
    },
    linklabel: {
        dataprivacy: 'Datenschutzerklärung',
        impressum: 'Impressum'
    },
    languages: {
        de: 'Deutsch',
        en: 'Englisch',
        pt: 'Portugiesisch'
    },
    language: {
        choose: {
            label: 'Wählen Sie Ihre Sprache:'
        }
    },
    hint: {
        instancename: 'Maximal 30 Zeichen, nur a-z, 0-9 und - erlaubt',
        appellation: 'Anrede',
        discountcode: 'Für eine spätere kostenpflichtige Lizenz',
        heardfrom: 'Wie haben Sie von uns gehört?',
        testChurchTools:
            '30 Tage KRZ.ChurchTools in vollem Funktionsumfang kostenlos testen. Die Testphase endet automatisch, ohne dass es einer Kündigung bedarf.',
        testChurchToolsPlusWebsite:
            '30 Tage KRZ.ChurchTools und ChurchTools Website in vollem Funktionsumfang kostenlos testen. Die Testphase endet automatisch, ohne dass es einer Kündigung bedarf.',
        testWebsite: 'ChurchTools Website in vollem Funktionsumfang kostenlos testen.',
        setupServiceOptional:
            'Wir helfen Ihnen gerne bei den ersten Schritten mit KRZ.ChurchTools und unterstützen Sie bei der Ersteinrichtung. Dazu bieten wir Ihnen ein kostenloses 1-stündiges Zoom-Meeting an, an welchem gerne auch weitere Personen aus Ihrer Kirchengemeinde teilnehmen können. Wir werden in dem Meeting gemeinsam die ersten Einstellungen an Ihrer neuen KRZ.ChurchTools-Installation vornehmen, damit Sie anschießend optimal weiter testen können.',
        setupServiceMandatory:
            'Wir helfen Ihnen bei den ersten Schritten mit KRZ.ChurchTools und unterstützen Sie bei der Ersteinrichtung. Dazu führen wir mit Ihnen ein kostenloses 1-stündiges Zoom-Meeting durch, an welchem gerne auch weitere Personen aus Ihrer Kirchengemeinde teilnehmen können. Wir werden in dem Meeting gemeinsam die ersten Einstellungen an Ihrer neuen KRZ.ChurchTools-Installation vornehmen, damit Sie anschießend optimal weiter testen können.',
        churchtoolsWebsite:
            'Mit <a href="https://church.tools/website" target="_blank">ChurchTools Website</a> präsentieren Sie Ihre Gemeinde ganz einfach mit vorgefertigten Layouts auf Ihre individuelle Art und Weise. Personen, Gruppen und Termine können Sie mit dem Editor mit wenigen Klicks auf der Webseite anzeigen lassen und direkt aus ChurchTools aktualisieren.',
        startTestphaseFromChurchTools:
            'Die Testphase für ChurchTools Website muss in diesem Fall direkt aus KRZ.ChurchTools gestartet werden. Gehen Sie im Verwalten-Menü auf "Öffentlichkeitsarbeit" und dann auf "ChurchTools Website".',
        contactSupportForCWBKircheHamburg:
            'Bitte kontaktieren Sie unseren Support (support@churchtools.de), nachdem Sie die Testphase von ChurchTools Website gestartet haben. Wir schalten Ihnen dann das extra Nordkirchen-Theme frei, sowie die Anbindung an die Veranstaltungsdatenbank der Nordkirche.',
        freeCombo:
            'Mit ChurchTools Website bekommt Ihre Kirchengemeinde auch ein dauerhaft kostenloses Combo-Paket von <a href="https://church.tools" target="_blank">ChurchTools</a>.',
        institutionId:
            'Ihre Institutions-ID finden Sie im Schnelleingabe-Interface der Kirchendankbank der Nordkirche. Sie wird benötigt, um Veranstaltungen aus der Kirchendatenbank in die Website zu übertragen.'
    },
    appellation: {
        mrs: 'Frau',
        mr: 'Herr',
        not_specified: 'keine Angabe'
    },
    heardfrom: {
        friend: 'Persönliche Empfehlung',
        church: 'In einer anderen Kirchengemeinde gesehen',
        google: 'Suchmaschine (z.B. Google, Yahoo, etc.)',
        facebook: 'Facebook',
        instagram: 'Instagram',
        capterra: 'Capterra',
        magazine: 'Zeitschrift',
        conference: 'Konferenz/Messe/Großveranstaltung',
        other: 'Andere'
    },
    buttonorderforfree: 'Kostenlos anfordern',
    requiredfield: '* zeigt ein benötigtes Feld an',
    email: {
        subject: {
            validation: '[KRZ.ChurchTools] Bestätigen Sie Ihre Registrierung',
            welcome: 'Willkommen bei KRZ.ChurchTools',
            day25: 'KRZ.ChurchTools Testphase endet in 5 Tagen',
            day30: 'Ihre kostenlose KRZ.ChurchTools Testphase endet heute',
            day45: 'Eine schlechte und eine gute Nachricht',
            day80: 'Konnten wir Sie nicht überzeugen?',
            day90: 'Auf Wiedersehen?',
            duplicate: '[KRZ.ChurchTools] Doppelte Installation',
            licenseChange: 'KRZ.ChurchTools Lizenzänderung',
            licenseOrderConfirmation: 'KRZ.ChurchTools Bestellbestätigung',
            soondeleteinstance: '[KRZ.ChurchTools] Ihre Installation is inaktiv',
            deleteinstance: '[KRZ.ChurchTools] Ihre Installation wurde gelöscht',
            newlicensemodel: 'Wichtige Neuigkeiten von KRZ.ChurchTools',
            siteCreated: 'KRZ.ChurchTools-Installation angelegt'
        },
        logo: 'https://ccp.church.tools/images/ct-logo-slogan-de.png'
    },
    header: {
        greeting: 'Hallo {appellation} {name}',
        register: 'Kostenlose KRZ.ChurchTools Installation anfordern',
        location: 'Ort: {location}',
        church: 'Kirchengemeinde: {church}'
    },
    register: {
        header: 'KRZ.ChurchTools 30 Tage kostenlos testen',
        headerWebsite: 'ChurchTools Website kostenlos testen',
        headerFinder: 'ChurchTools kostenlos für Finder-Profil registrieren',
        headerDenomination: 'KRZ.ChurchTools registrieren bei',
        headerDenominationWebsite: 'ChurchTools Website registrieren bei',
        headerDenominationUpdateAdmin: 'KRZ.ChurchTools-Admin aktualisieren bei',
        headerinstanceavailable:
            '🎉 Glückwunsch, diese Adresse ist noch frei. KRZ.ChurchTools jetzt 30 Tage kostenlos testen',
        finished: {
            description:
                'Um die Installation abzuschließen, bestätigen Sie bitte Ihre E-Mail Adresse. Wir haben Ihnen dazu eine E-Mail an {email} geschickt. Bitte klicken Sie auf den Link in der E-Mail.',
            descriptionDenomination:
                'Die KRZ.ChurchTools Installation wird nun bereit gestellt. Das kann ein paar Minuten dauern.</br></br>Sobald dies abgeschlossen ist, schicken wir eine Mail an</br>{email} (Administrator)</br>und</br>{denominationEmail} ({denominationName}).',
            duplicate:
                'Danke für die Registrierung! Unser Support Team kümmert sich um die Installation und schickt Ihnen eine E-Mail an {email}.',
            header: 'Ihre KRZ.ChurchTools Installation\nwurde angefordert!',
            resend: 'Mail erneut versenden',
            editEmail: 'E-Mail Adresse korrigieren',
            resendEmail: {
                success: 'Die E-Mail zur Valdierung Ihrer E-Mail Adresse wurde erneut versendet!',
                error: 'Die E-Mail konnte nicht verschickt werden, bitte versuches sie es später noch einmal'
            },
            saveEmail: 'Speichern',
            changeEmail: {
                success:
                    'Die E-Mail Adresse wurde erfolgreich geändert. Die Mail zur Bestätigung Ihrer E-Mail Adresse wurde erneut versendet',
                error: 'Die E-Mail Adresse konnte nicht geändert werden.'
            },
            status: 'Einrichtungsstatus',
            again: 'Weitere Installation registrieren'
        }
    },
    setup: {
        status: {
            header: 'Vielen Dank für die Validierung Ihrer E-Mail Adresse!',
            headerDenomination: 'Vielen Dank für die Registrierung!',
            description:
                'Ihre KRZ.ChurchTools Installation wird nun für Sie bereit gestellt. Das kann ein paar Minuten dauern. Bitte gedulden Sie sich einen Moment.',
            error:
                'Leider ist bei Ihrer Installation ein Fehler aufgetreten. Wir bemühen uns diesen so schnell wie möglich zu beheben und kontaktieren Sie über Ihre E-Mail Adresse {email}.'
        },
        finished: {
            header: 'Die Installation ist abgeschlossen',
            description:
                'Sie können sich nun mit Ihrer E-Mail {email} und Passwort "admin" unter <a href="https://{siteName}.krz.tools">https://{siteName}.krz.tools</a> anmelden.',
            descriptionWebsite:
                'Sie können sich nun mit den Zugangsdaten aus der Willkommens-E-Mail anmelden und dann Ihr Passwort ändern.',
            login: 'Zum Login'
        }
    },
    validation: {
        wait: 'Validiere mit Token\n{token},\nbitte warten Sie...',
        email: '{email} muss eine gültige E-Mail Adresse sein.',
        empty: 'Das Feld darf nicht leer sein.',
        exactlength: 'Das Feld muss eine Anzahl von {length} Zeichen haben.',
        allowed: 'Das Feld muss eines folgender Werte sein: {allowed}',
        length: 'Das Feld muss zwischen {min} und {max} Zeichen enthalten.',
        minlength: 'Das Feld muss mindestens {min} Zeichen enthalten.',
        maxlength: 'Das Feld darf maximal {max} Zeichen enthalten.',
        sitename: {
            invalidchars: 'Das Feld enthält ungültige Zeichen. Nur a-z, 0-9 und - sind erlaubt.',
            taken: 'Der Kurzname ist schon vergeben.',
            notYetKnown: 'Der Kurzname ist noch nicht bekannt.'
        },
        errorHeader: 'Fehler bei Validierung der E-Mail.',
        churchname: 'Bitte geben Sie den vollständigen Name Ihrer Kirchengemeinde an (mindestens 5 Zeichen).',
        duplicateEmail: 'Nur eine Installation pro Kirchengemeinde ist erlaubt.',
        adminAlreadyExists: 'Es existiert bereits ein Admin in dieser Installation. Update nicht möglich.'
    },
    error: {
        fielderrors: 'Beim Validieren sind Fehler aufgetreten.',
        noresendtoken: 'Parameter resendtoken fehlt.',
        notoken: 'Parameter token fehlt.',
        novalidationtoken: 'Parameter validationtoken fehlt.',
        emailvalidated: 'Die E-Mail wurde schon validiert.',
        sitenamealreadyprogress: 'Eine Installation mit dem gleichen Seitennamen läuft schon.',
        tokeninvalid:
            'Der Link ist nicht mehr gültig. Bitte versuchen Sie eine erneute Registrierung oder wenden Sie sich an den Support (support@KRZ.ChurchTools.de)',
        licensekeyinvalid: 'Der Lizenschlüssel ist nicht valide.',
        internal:
            'Leider ist bei Ihrer Installation ein Fehler aufgetreten. Wir bemühen uns diesen so schnell wie möglich zu beheben und kontaktieren Sie über Ihre E-Mail Adresse {email}.'
    },
    countries: {
        '---': '-----',
        AF: 'Afghanistan',
        EG: 'Ägypten',
        AX: 'Aland',
        AL: 'Albanien',
        DZ: 'Algerien',
        AS: 'Amerikanisch-Samoa',
        VI: 'Amerikanische Jungferninseln',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarktis',
        AG: 'Antigua und Barbuda',
        GQ: 'Äquatorialguinea',
        AR: 'Argentinien',
        AM: 'Armenien',
        AW: 'Aruba',
        AC: 'Ascension',
        AZ: 'Aserbaidschan',
        ET: 'Äthiopien',
        AU: 'Australien',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesch',
        BB: 'Barbados',
        BE: 'Belgien',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivien',
        BA: 'Bosnien und Herzegowina',
        BW: 'Botswana',
        BV: 'Bouvetinsel',
        BR: 'Brasilien',
        VG: 'Britische Jungferninseln',
        IO: 'Britisches Territorium im Indischen Ozean',
        BN: 'Brunei',
        BG: 'Bulgarien',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CL: 'Chile',
        CN: 'China, Volksrepublik',
        CK: 'Cookinseln',
        CR: 'Costa Rica',
        DK: 'Dänemark',
        DE: 'Deutschland',
        SH: 'Die Kronkolonie St. Helena und Nebengebiete',
        DG: 'Diego Garcia',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DJ: 'Dschibuti',
        EC: 'Ecuador',
        SV: 'El Salvador',
        ER: 'Eritrea',
        EE: 'Estland',
        EU: 'Europäische Union',
        FK: 'Falklandinseln',
        FO: 'Färöer',
        FJ: 'Fidschi',
        FI: 'Finnland',
        FR: 'Frankreich',
        GF: 'Französisch-Guayana',
        PF: 'Französisch-Polynesien',
        TF: 'Französische Süd- und Antarktisgebiete',
        GA: 'Gabun',
        GM: 'Gambia',
        GE: 'Georgien',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GD: 'Grenada',
        GR: 'Griechenland',
        GL: 'Grönland',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard und McDonaldinseln',
        HN: 'Honduras',
        HK: 'Hongkong',
        IN: 'Indien',
        ID: 'Indonesien',
        IQ: 'Irak',
        IR: 'Iran',
        IE: 'Irland',
        IS: 'Island',
        IM: 'Isle of Man',
        IL: 'Israel',
        IT: 'Italien',
        JM: 'Jamaika',
        JP: 'Japan',
        YE: 'Jemen',
        JE: 'Jersey',
        JO: 'Jordanien',
        KY: 'Kaimaninseln',
        KH: 'Kambodscha',
        CM: 'Kamerun',
        CA: 'Kanada',
        IC: 'Kanarische Inseln',
        CV: 'Kap Verde',
        KZ: 'Kasachstan',
        QA: 'Katar',
        KE: 'Kenia',
        KG: 'Kirgisistan',
        KI: 'Kiribati',
        CC: 'Kokosinseln',
        CO: 'Kolumbien',
        KM: 'Komoren',
        CD: 'Kongo, Demokratische Republik',
        HR: 'Kroatien',
        CU: 'Kuba',
        KW: 'Kuwait',
        LA: 'Laos',
        LS: 'Lesotho',
        LV: 'Lettland',
        LB: 'Libanon',
        LR: 'Liberia, Republik',
        LY: 'Libyen',
        LI: 'Liechtenstein',
        LT: 'Litauen',
        LU: 'Luxemburg',
        MO: 'Macao',
        MG: 'Madagaskar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Malediven',
        ML: 'Mali, Republik',
        MT: 'Malta',
        MA: 'Marokko',
        MH: 'Marshallinseln',
        MQ: 'Martinique',
        MR: 'Mauretanien',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MK: 'Mazedonien',
        MX: 'Mexiko',
        FM: 'Mikronesien, Föderierte Staaten von',
        MD: 'Moldawien',
        MC: 'Monaco',
        MN: 'Mongolei',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MZ: 'Mosambik',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NC: 'Neukaledonien',
        NZ: 'Neuseeland',
        NT: 'Neutrale Zone (Irak)',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        AN: 'Niederländische Antillen',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        KP: 'Nordkorea',
        MP: 'Nördliche Marianen',
        NF: 'Norfolkinsel',
        NO: 'Norwegen',
        OM: 'Oman',
        AT: 'Österreich',
        TL: 'Osttimor',
        PK: 'Pakistan',
        PS: 'Palästinensische Autonomiegebiete',
        PW: 'Palau',
        PA: 'Panama',
        PG: 'Papua-Neuguinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippinen',
        PN: 'Pitcairninseln',
        PL: 'Polen',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        CI: 'Republik Côte d’Ivoire',
        CG: 'Republik Kongo',
        RE: 'Réunion',
        RW: 'Ruanda',
        RO: 'Rumänien',
        RU: 'Russische Föderation',
        SB: 'Salomonen',
        ZM: 'Sambia',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'São Tomé und Príncipe',
        SA: 'Saudi-Arabien',
        SE: 'Schweden',
        CH: 'Schweiz',
        SN: 'Senegal',
        RS: 'Serbien',
        CS: 'Serbien und Montenegro',
        SC: 'Seychellen',
        SL: 'Sierra Leone',
        ZW: 'Simbabwe',
        SG: 'Singapur',
        SK: 'Slowakei',
        SI: 'Slowenien',
        SO: 'Somalia, Demokratische Republik',
        SU: 'Sowjetunion',
        ES: 'Spanien',
        LK: 'Sri Lanka',
        KN: 'St. Kitts und Nevis',
        LC: 'St. Lucia',
        PM: 'St. Pierre und Miquelon',
        VC: 'St. Vincent und die Grenadinen',
        ZA: 'Südafrika',
        SD: 'Sudan',
        GS: 'Südgeorgien und die Südlichen Sandwichinseln',
        KR: 'Südkorea',
        SR: 'Suriname',
        SJ: 'Svalbard und Jan Mayen',
        SZ: 'Swasiland',
        SY: 'Syrien',
        TJ: 'Tadschikistan',
        TW: 'Taiwan',
        TZ: 'Tansania',
        TH: 'Thailand',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad und Tobago',
        TA: 'Tristan da Cunha',
        TD: 'Tschad',
        CZ: 'Tschechien',
        TN: 'Tunesien',
        TR: 'Türkei',
        TM: 'Turkmenistan',
        TC: 'Turks- und Caicosinseln',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        HU: 'Ungarn',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VU: 'Vanuatu',
        VA: 'Vatikanstadt',
        VE: 'Venezuela',
        AE: 'Vereinigte Arabische Emirate',
        US: 'Vereinigte Staaten von Amerika',
        GB: 'Vereinigtes Königreich',
        VN: 'Vietnam',
        WF: 'Wallis und Futuna',
        CX: 'Weihnachtsinsel',
        BY: 'Weißrussland',
        EH: 'Westsahara',
        CF: 'Zentralafrikanische Republik',
        CY: 'Zypern, Republik',
        BQ: 'Bonaire',
        BL: 'Saint-Barthélemy',
        MF: 'Saint Martin',
        KO: 'Kosovo',
        SS: 'South Sudan',
        CW: 'Curacao',
        SX: 'Sint Maarten',
        UM: 'United States Minor Outlying Islands'
    },
    support: {
        dashboard: {
            tabs: {
                errors: 'Fehler',
                pendings: 'Unerledigt',
                duplicates: 'Duplikate',
                inprogress: 'in Arbeit',
                finished: 'Erledigt',
                usage: 'Nutzung'
            },
            searchButton: 'suchen',
            instancename: 'Instanzname'
        },
        table: {
            updated: 'Aktualisiert',
            product: 'Produkt',
            sitename: 'Instanzname',
            churchname: 'Kirchenname',
            username: 'Kontaktname',
            email: 'E-Mail',
            baselanguage: 'Grundsprache',
            cta: 'Call to Action',
            status: 'Status'
        },
        registrationDetails: {
            header: 'Registrierungsdaten',
            contactData: 'Kontaktdaten',
            churchData: 'Kirchen-Informationen',
            isDuplicate: 'Ist Duplikat',
            sendNotice: 'Mit Benachrichtigung',
            noDuplicate: 'Kein Duplikat',
            name: 'Name:',
            email: 'Email:',
            phone: 'Telefon:',
            registerLanguage: 'Registrierungs-Sprache:',
            churchName: 'Kirchename:',
            city: 'Stadt:',
            country: 'Land:',
            baseLanguage: 'Sprache:',
            instanceName: 'KRZ.ChurchTools Kurzname:',
            website: 'Webseite:',
            furtherInformation: 'Weitere Informationen',
            heardFrom: 'Gehört von:',
            discount: 'Rabatt:',
            license: 'Lizenz:',
            created: 'Erstellt:',
            userAgent: 'Browser:',
            logs: 'Logs',
            comment: 'Kommentar',
            cta: 'Call to action:',
            linkfreescout: 'Finde in FreeScout',
            addcomment: 'Kommentar hinzufügen',
            proceedinstallation: 'Mit Installation fortfahren',
            lastupdate: 'Aktualisiert:',
            markdone: 'Markiere als Erledigt',
            infomails: 'Infomails:',
            newsletter: 'Newsletter:'
        },
        usageDetails: {
            header: 'Nutzungsdaten',
            usageLicenseData: 'Lizenz-relevante Nutzungsdaten',
            persons: 'Personen',
            services: 'Dienste',
            resources: 'Ressourcen',
            calendars: 'Kalender',
            stations: 'Stationen',
            usageDataLast30Days: 'Neue Einträge in den letzen 30 Tagen',
            persons30: 'Personen',
            personsActive30Days: 'Personen eingeloggt',
            groups30: 'Gruppen',
            csEntries30: 'Dienst-Einteilungen',
            crEntries30: 'Ressource-Buchungen',
            calEntries30: 'Termine',
            licenseOverUnder: 'Über-/Unterlizensierung',
            overLicensed: 'überlizensiert',
            underLicensed: 'unterlizensiert'
        },
        setupState: {
            duplicate: 'Duplikat',
            possibleduplicate: 'mögliches Duplikat',
            error: 'Fehler',
            pending: 'Wartet auf Emailbestätigung',
            done: 'Erledigt',
            inprogress: 'in Arbeit',
            manuelDone: 'Als Erledigt markiert'
        },
        registrationOverview: {
            noDataFound: 'Keine Einträge vorhanden'
        },
        duplicates: {
            header: 'Mögliches Duplikat von',
            intern: 'INTERN',
            ccp: 'CCP',
            tableColumn: {
                type: 'TYP',
                churchName: 'Gemeindename',
                email: 'E-Mail',
                phone: 'Telefon',
                city: 'Stadt',
                country: 'Land',
                website: 'Webseite',
                setupState: 'Setup Status'
            }
        },
        login: {
            error: 'Benutzername oder Passwort ist falsch.'
        }
    },
    license: {
        tax: {
            nStb: 'Umsatz im Inland nicht steuerbar.',
            nStbUstID: 'Steuerschuldnerschaft des Leistungsempfängers. Ihre UStID-Nr. lautet: {ustid}',
            MwSt: '19% MwSt.'
        },
        discount: {
            discountAmountOnSum: '{amount} auf die Summe{comment}',
            discountAmountOnPart: '{amount} auf {part}{comment}',
            discountPercentOnSum: '{percent}% auf die Summe{comment}',
            discountPercentOnPart: '{percent}% auf {part}{comment}',
            fixPriceForSum: 'Fixer Gesamt-Preis{comment}',
            fixPriceForPart: 'Fixer Preis für {part}{comment}',
            minPriceForSum: 'Aufstockung auf vereinbarten Mindest-Gesamtpreis von {price}{comment}',
            minPriceForPart: 'Aufstockung auf vereinbarten Mindest-Preis von {price} für {part}{comment}'
        },
        yes: 'ja',
        no: 'nein',
        dateformat: 'DD.MM.YYYY',
        unlimited: 'unbegrenzt',
        financeClients: 'Mandanten',
        syncConnections: 'Sync-Verbindungen'
    },
    demo: {
        header: 'KRZ.ChurchTools Demo',
        information: {
            header: 'Informationen zur Demo',
            text:
                'Die KRZ.ChurchTools Demo-Installation ist mit Beispieldaten gefüllt, um KRZ.ChurchTools zu erkunden. Diese Installation ist kostenlos und wird nach 3 Tagen automatisch gelöscht.'
        },
        support: {
            text: 'Bei Fragen steht Ihnen unser Supportteam gerne zur Verfügung.',
            contact: 'Support kontaktieren'
        },
        create: {
            button: 'Demo erstellen',
            spinner: 'Wir erstellen eine neue Demo für Sie. Dies kann bis zu einer Minute dauern.'
        },
        churchtools: {
            button: 'KRZ.ChurchTools aufrufen',
            text: 'Ihre Demo wurde erstellt'
        },
        error: {
            header: 'Da lief was schief',
            text:
                'Da ist uns wohl ein Fehler unterlaufen. Leider konnte keine KRZ.ChurchTools Demo erstellt werden. Bitte laden Sie die Seite neu und versuchen es erneut. Falls das Problem weiterhin besteht hilft unser Support gerne weiter.',
            reload: 'Neuladen'
        },
        template: {
            label: 'Wählen Sie eine Demo:',
            freikirche: 'Freikirchlich',
            evangelisch: 'Evangelisch',
            katholisch: 'Katholisch',
            cvjm: 'CVJM'
        }
    }
};
